import { render, staticRenderFns } from "./educationPlanTabOld.vue?vue&type=template&id=100e3489"
import script from "./educationPlanTabOld.vue?vue&type=script&lang=js"
export * from "./educationPlanTabOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('100e3489')) {
      api.createRecord('100e3489', component.options)
    } else {
      api.reload('100e3489', component.options)
    }
    module.hot.accept("./educationPlanTabOld.vue?vue&type=template&id=100e3489", function () {
      api.rerender('100e3489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationPlanTabOld.vue"
export default component.exports